import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const productSlice = createApi({
    reducerPath: "productSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getProducts: builder.query({
            query: ({ page = 1, limit = 100, search = "", catId = "" }) => ({
                url: `/product?page=${page}&limit=${limit}&search=${search}&catId=${catId}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Categorys
        addProduct: builder.mutation({
            query: (body) => ({
                url: "/product",
                method: "POST",
                body,
            }),
        }),

        getSingleProduct: builder.query({
            query: (id) => ({
                url: `/product/${id}`,
                method: "GET",

            }),
        }),

        // ✅ Update Existing Category
        updateProduct: builder.mutation({
            query: ({ id, body }) => ({
                url: `/product/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteProduct: builder.mutation({
            query: (id) => ({
                url: `/product/${id}`,
                method: "DELETE",
            }),
        }),


        getProductSubCat: builder.query({
            query: (categoryId) => `/subcategory/category/${categoryId}`,
        }),

        getProductServiceTypes: builder.query({
            query: (subCategoryId) => `/subCategoryType/subcategory/${subCategoryId}`,
        }),





    }),
});

export const {
    useGetProductsQuery,
    useAddProductMutation,
    useGetSingleProductQuery,
    useUpdateProductMutation,
    useDeleteProductMutation,
    useGetProductSubCatQuery,
    useGetProductServiceTypesQuery,
} = productSlice;
